import React from "react";
import { motion } from "framer-motion";
import { Globe2, Users, Plane, Star } from "lucide-react";

const APropos = () => {
  return (
    <div className="container mx-auto px-6 py-12">
      {/* Section intro */}
      <motion.section
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl font-extrabold text-blue-700 mb-4">
          🌍 À propos de Djater Voyage
        </h1>
        <p className="text-gray-700 text-lg max-w-3xl mx-auto">
          Depuis notre création, nous aidons des milliers de voyageurs à
          explorer le monde autrement. Notre mission est simple : rendre chaque
          voyage unique, accessible et inoubliable.
        </p>
      </motion.section>

      {/* Valeurs clés */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        {[
          {
            icon: <Users className="w-10 h-10 text-blue-600" />,
            title: "Équipe dévouée",
            desc: "Des experts passionnés qui vous accompagnent avant, pendant et après vos voyages.",
          },
          {
            icon: <Plane className="w-10 h-10 text-blue-600" />,
            title: "Voyages sur mesure",
            desc: "Nous adaptons chaque circuit à vos envies, que ce soit l’aventure, le luxe ou la découverte culturelle.",
          },
          {
            icon: <Star className="w-10 h-10 text-blue-600" />,
            title: "Satisfaction garantie",
            desc: "Plus de 95% de nos clients recommandent nos services à leurs proches.",
          },
        ].map((valeur, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: idx * 0.2 }}
            className="bg-white rounded-2xl shadow-lg p-6 text-center border-2 border-blue-100 hover:shadow-2xl transition"
          >
            <div className="flex justify-center mb-4">{valeur.icon}</div>
            <h3 className="font-bold text-xl text-blue-800 mb-2">
              {valeur.title}
            </h3>
            <p className="text-gray-600">{valeur.desc}</p>
          </motion.div>
        ))}
      </div>

      {/* Section Contact */}
      <motion.section
        id="contact"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-blue-50 rounded-2xl shadow-xl p-8"
      >
        <h2 className="text-3xl font-bold text-blue-700 mb-6 text-center">
          📩 Contactez-nous
        </h2>
        <form className="max-w-2xl mx-auto space-y-4">
          <input
            type="text"
            placeholder="Votre nom"
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
          />
          <input
            type="email"
            placeholder="Votre email"
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
          />
          <textarea
            placeholder="Votre message"
            rows="4"
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
          ></textarea>
          <button
            type="submit"
            className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-8 rounded-full shadow-xl transition transform hover:scale-105 mx-auto"
          >
            <Globe2 className="w-5 h-5" />
            Envoyer le message
          </button>
        </form>
      </motion.section>
    </div>
  );
};

export default APropos;
